import Proxy from '../Proxy';

class StatsOrdersDryCleaningByManagerProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/dry-cleaning-by-managers', parameters);
  }
}

export default StatsOrdersDryCleaningByManagerProxy;
